import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  API,
  NewMessageRequestActions,
  GlobalActions,
  DisplayActions,
  NavigationHelper,
  TableMessages,
  VibeButton,
  viAdd,
  color,
  withRouter,
} from 'vibeguide';
import MessageSidebar from '../../../../Messages/NewMessageRequest/Sidebar/MessageSidebar';
import './Messages.scss';

class Messages extends Component {
  constructor(props) {
    super(props);

    this.sidebarTimeout = null;
  }

  componentDidMount() {
    const qs = NavigationHelper.getParams();
    const isNew = qs.type === 'new';
    const isView = qs.messageId && qs.type !== 'new';

    if (isNew || isView) {
      this.sidebarTimeout = setTimeout(() => {
        this.sidebar(qs.type, qs.messageId);
      }, 1500);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: {
        search,
      },
    } = this.props;

    const {
      location: {
        search: prevSearch,
      },
    } = prevProps;

    if (search !== prevSearch) {
      const qs = NavigationHelper.getParams();

      if (qs.messageId || qs.type === 'new') {
        this.sidebar(qs.type, qs.messageId);
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.sidebarTimeout);
  }

  showDisplayPlayer = async (e, messages) => {
    const {
      setDisplay,
    } = this.props;

    e.preventDefault();
    e.stopPropagation();

    setDisplay({
      show: true,
      messages,
      isLoop: false,
    });
  };

  showSidebarDisplayPlayer = async (messages) => {
    const {
      setDisplay,
    } = this.props;

    setDisplay({
      show: true,
      messages,
      isLoop: true,
    });
  };

  /**
   * When the sidebar is closed
   */
  onCloseSidebar = () => {
    const {
      history,
    } = this.props;

    const url = NavigationHelper.updateParams({
      messageId: null,
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  /**
   * Get the columns for Ad Type Messages based on user context
   */
  getAdColumns = () => {
    const {
      user,
    } = this.props;

    const isISMAdmin = user.accountType !== 'partner' && user.can('admin.ism_admin');
    const isContentCurator = user.can('message.content_curator');
    const isClientUser = user.accountType !== 'partner';

    if (isISMAdmin || isContentCurator) {
      return [
        '.',
        'Message Name',
        'Media Format',
        'Company',
        'Partner',
        'Advertiser',
        'Ad Category',
        'Last Updated',
        'Requester',
        'Start Date',
        'End Date',
        'Duration',
        'Script',
        'Assigned Voice Talent',
        'Tags',
        '...',
      ];
    }

    if (isClientUser) {
      return [
        '.',
        'Message Name',
        'Media Format',
        'Company',
        'Advertiser',
        'Ad Category',
        'Last Updated',
        'Requester',
        'Start Date',
        'End Date',
        'Duration',
        'Script',
        'Assigned Voice Talent',
        'Tags',
        '...',
      ];
    }

    return [
      '.',
      'Message Name',
      'Media Format',
      'Advertiser',
      'Ad Category',
      'Last Updated',
      'Requester',
      'Start Date',
      'End Date',
      'Duration',
      'Script',
      'Assigned Voice Talent',
      'Tags',
      '...',
    ];
  };

  /**
   * Determine whether or not to show or hide the sidebar
   */
  sidebar = (type, messageId = null) => {
    const {
      setPanel,
    } = this.props;

    setPanel({
      show: true,
      backdrop: type === 'new',
      children: (
        <MessageSidebar
          type={type === 'new'
            ? 'request'
            : 'library'}
          messageId={messageId}
          isNew={type === 'new'}
          isDuplicate={type === 'new' && messageId !== null}
          showDisplayPlayer={this.showSidebarDisplayPlayer}
        />
      ),
      onClose: this.onCloseSidebar,
    });
  };

  render() {
    const {
      currentLocation: {
        _id: locationId,
      },
      currentLocation,
      user,
    } = this.props;

    const mediaFormatSubItems = currentLocation.mediaFormat !== 'visual' ? [
      {
        name: 'Regular',
        show: user.can('message.view'),
        enabled: true,
        paginatorLabel: 'Messages',
      },
      {
        name: 'Ads',
        show: user.can('advertisement.view'),
        enabled: true,
        filters: {
          messageType: 'ad',
        },
        columns: this.getAdColumns(),
      },
      {
        name: 'External Ads',
        show: user.can('advertisement.view'),
        enabled: true,
        filters: {
          messageType: 'ext-ad',
        },
        columns: this.getAdColumns(),
      },
      {
        name: 'Sounders',
        show: user.isAdminCompany && user.can('message.view'),
        enabled: false,
        filters: {
          messageType: 'sounder',
        },
      },
      {
        name: 'Air Checks',
        show: user.isAdminCompany && user.can('message.view'),
        enabled: true,
        filters: {
          messageType: 'air',
        },
      },
      {
        name: 'Spec Spots',
        show: user.isAdminCompany && user.can('message.view'),
        enabled: true,
        filters: {
          messageType: 'spec',
        },
      }] : [
      {
        name: 'Self Promotion',
        show: user.can('message.view'),
        enabled: true,
        paginatorLabel: 'Messages',
      },
      {
        name: 'Ads',
        show: user.can('advertisement.view'),
        enabled: true,
        filters: {
          messageType: 'ad',
        },
      },
      {
        name: 'Ad Uploads',
        show: user.can('advertisement.view'),
        enabled: true,
        filters: {
          messageType: 'ext-ad',
        },
      }];

    return (
      <div className="Messages">
        <TableMessages
          columns={[
            '.',
            'Message Name',
            'Media Format',
            'Last Updated',
            'Requester',
            'Start Date',
            'End Date',
            'Duration',
            'Script',
            'Assigned Voice Talent',
            'Tags',
            '...',
          ]}
          fetch={API.Location.listMessages}
          fetchProps={{
            filters: {
              _id: locationId,
            },
          }}
          defaultSortBy={{
            label: 'Last Updated',
            attr: 'modifiedDate',
            direction: 'desc',
          }}
          paginator
          paginatorProps={{
            label: 'Messages',
            urlPaging: true,
            urlFilters: true,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Messages',
            tooltip: true,
          }}
          bulk
          bulkProps={{
            edit: true,
            add: false,
            block: false,
            remove: false,
            archive: true,
          }}
          submenu
          submenuProps={{
            rootUrl: `/location/${locationId}/assignments/messages`,
            style: {
              borderTop: `1px solid ${color.whiteSmoke}`,
            },
            items: mediaFormatSubItems,
          }}
          rowLink={{
            messageId: '_id',
          }}
          menuItems={(row) => {
            const isAd = row.messageType === 'ad'
              || row.messageType === 'ext-ad';

            return [{
              name: 'Archive',
              userCan: isAd
                ? 'advertisement.delete'
                : 'message.delete',
            }];
          }}
          toolbarProps={{
            customButtons: user.can('message.request') || user.can('advertisement.request')
              ? [
                (
                  <VibeButton
                    key="button-new-message"
                    text="New Message"
                    color="primary"
                    icon={viAdd}
                    tooltip="New Message"
                    tooltipProps={{
                      placement: 'top',
                    }}
                    link={NavigationHelper.updateParams({
                      type: 'new',
                    })}
                  />
                ),
              ]
              : [],
          }}
          showDisplayPlayer={this.showDisplayPlayer}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
    currentLocation: state.locations.currentLocation,
  };
}

const mapDispatchToProps = {
  setMessageCompany: NewMessageRequestActions.setMessageCompany,
  addMessageLocation: NewMessageRequestActions.addLocation,
  setLastUrl: GlobalActions.setLastUrl,
  setPanel: GlobalActions.setPanel,
  setDisplay: DisplayActions.setDisplay,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Messages));
